<template>
  <div class="apply_electronic_main">
    <div class="apply_electronic_main_divA">
      <div class="use_box_h2">稳定高效，降低业务成本</div>
      <div class="use_box_text">
        奇迹ip提供安全可靠的代理服务，提高业务效率，助力您的业务增长
      </div>
      <div class="use_s">
        <div class="use">
          <div class="card">
            <img
              src="http://apiupss.ppfly.top/images/use_img_1.svg"
              alt=""
              class="use_img"
            />
            <div class="name_box">
              <div class="card_name">
                <img
                  src="http://apiupss.ppfly.top/images/use_icon_1.svg"
                  alt=""
                />
                真实匿名
              </div>
            </div>
          </div>
          <div class="card_text">
            <p class="use_tit">真实匿名</p>
            <p class="use_text">
              源自家庭住宅设备，以真实用户身份采集公开数据，安全性更高
            </p>
          </div>
        </div>

        <div class="use">
          <div class="card">
            <img
              src="http://apiupss.ppfly.top/images/use_img_2.svg"
              alt=""
              class="use_img"
            />
            <div class="name_box">
              <div class="card_name">
                <img
                style="width: 20px;"
                  src="http://apiupss.ppfly.top/images/use_icon_2.png"
                  alt=""
                />
                精准定位
              </div>
            </div>
          </div>
          <div class="card_text">
            <p class="use_tit">精准定位</p>
            <p class="use_text">
              全球国家地区任意选择，根据指定的国家、城市、运营商获取所需IP
            </p>
          </div>
        </div>

        <div class="use">
          <div class="card">
            <img
              src="http://apiupss.ppfly.top/images/use_img_3.svg"
              alt=""
              class="use_img"
            />
            <div class="name_box">
              <div class="card_name">
                <img
                  src="http://apiupss.ppfly.top/images/use_icon_3.svg"
                  alt=""
                />
                 并发请求
              </div>
            </div>
          </div>
          <div class="card_text">
            <p class="use_tit">无限并发请求</p>
            <p class="use_text">
              不限制并发请求，不限制IP提取次数，不收取额外费用，降低业务成本
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply_electronic_main_div">
      <div class="apply_electronic_main_div_left">
        <div>
          <div class="apply_electronic_main_div_left_H1">
            如何使用奇迹ip代理？
          </div>
          <div class="apply_electronic_main_div_left_text">
            多种代理使用方式，灵活选择，满足您的业务需求
          </div>
        </div>
        <div>
          <div class="apply_electronic_main_div_left_textB">
            <i class="el-icon-circle-check"></i> API获取 —
            添加多个白名单，API链接快速提取
          </div>
          <div class="apply_electronic_main_div_left_textB">
            <i class="el-icon-circle-check"></i> 账密认证 —
            添加多个认证账户，灵活调整参数
          </div>
        </div>
        <div>
          <div class="apply_electronic_main_butts">
            <div class="apply_electronic_main_butt">获取免费IP</div>
          </div>
        </div>
      </div>
      <div class="apply_electronic_main_div_reft">
        <img
          style="width: 620px"
          src="http://apiupss.ppfly.top/images/get_img.svg"
          alt=""
        />
      </div>
    </div>

    <div class="apply_electronic_main_divB">
      <div class="apply_electronic_main_div_left_H2">拓展业务，从奇迹ip开始</div>
      <div class="apply_electronic_main_divB_div">
        <div>
          <div>确定目标URL</div>
          <div>根据您需要抓取的网站特点，选择目标域并指定其他参数</div>
          <div class="apply_electronic_yuan">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div>
          <div>发送请求</div>
          <div>通过HTTP(S)协议，获取HTML文档或JSON数据</div>
          <div class="apply_electronic_yuan">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div>
          <div>数据解析和处理</div>
          <div>解析并处理HTML文档或JSON数据，进行数据分析</div>
        </div>
      </div>
    </div>

    <div class="apply_electronic_main_div_left_H3">奇迹ip代理优势</div>
    <div class="advantage_center">
      <div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src="http://apiupss.ppfly.top/images/ad_icon_1.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">亿级代理资源</p>
          </div>
          <p class="ad_txt">
            提供1亿多个优质IP，并持续扩充代理池，确保您可以随时获得高质量的代理IP
          </p>
          <p class="bg"></p>
        </div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src=" http://apiupss.ppfly.top/images/ad_icon_3.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">99.9% IP可用率</p>
          </div>
          <p class="ad_txt">
            定时对代理池进行清洗加速，支持IP自动去重，IP可用率高达99.9%
          </p>
          <p class="bg"></p>
        </div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src=" http://apiupss.ppfly.top/images/ad_icon_2.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">自建代理池</p>
          </div>
          <p class="ad_txt">
            奇迹ip自建纯净代理池，所有IP经过技术层算法过滤，严格筛选优质IP资源
          </p>
          <p class="bg"></p>
        </div>
      </div>
      <div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src=" http://apiupss.ppfly.top/images/ad_icon_4.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">高带宽配速</p>
          </div>
          <p class="ad_txt">
            强大的代理基础架构，承载亿级并发，时刻保持负载均衡，保证您的访问速度和稳定性
          </p>
          <p class="bg"></p>
        </div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src=" http://apiupss.ppfly.top/images/ad_icon_5.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">代理多样化</p>
          </div>
          <p class="ad_txt">
            支持白名单验证，通过API链接快速连接，账密认证模式，灵活调整参数
          </p>
          <p class="bg"></p>
        </div>
        <div class="ad_card">
          <div class="ad_card_top">
            <img
              src=" http://apiupss.ppfly.top/images/ad_icon_6.svg"
              alt=""
              class="ad_icon"
            />
            <p class="ad_tit">快速响应</p>
          </div>
          <p class="ad_txt">
            API接口自动化配置，毫秒级操作响应，快速连接，拓展业务
          </p>
          <p class="bg"></p>
        </div>
      </div>
    </div>

    <div class="free_serve wow slideInIndex" style="visibility: visible">
      <div class="fs_l">
        <h2>企业及大客户定制</h2>
        <p>根据您的业务需求量身定制解决方案</p>
      </div>
      <div class="fs_c">
        <p class="fs_li">
          <i class="el-icon-check"></i>
          更低价格
        </p>
        <p class="fs_li">
          <i class="el-icon-check"></i>
          专属资源池
        </p>
        <p class="fs_li">
          <i class="el-icon-check"></i>
          免费业务分析
        </p>
        <p class="fs_li">
          <i class="el-icon-check"></i>
          定制IP时效
        </p>
        <p class="fs_li">
          <i class="el-icon-check"></i>
          定制功能
        </p>
        <p class="fs_li">
          <i class="el-icon-check"></i>
          现场服务支持
        </p>
      </div>
      <div class="fs_r">
        <div class="r_btn">
          <img src="/images/apply_new/fs_sever_icon.svg" alt="" />联系客服
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "apply_electronic_mainkey",
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.card_name {
  width: 128px;
  height: 47px;
  background: #edf3fc;
  box-shadow: 0 4px 33px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #292626;
  line-height: 28px;
  margin-top: 10px;
}
.apply_electronic_main_divA {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 150px;
}
.use_s {
  width: 68%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.card {
  width: 332px;
  margin: 0 auto;
  height: 334px;
  background: #fafafa;
  border-radius: 15px;
  box-sizing: border-box;
  padding-top: 42px;
}
.use_tit {
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #292626;
  line-height: 26px;
}
.use_text {
  width: 330px;
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  line-height: 26px;
  margin-top: 6px;
}
.use_box_h2 {
  margin-top: 200px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  line-height: 44px;
  margin-bottom: 29px;
  text-align: center;
}
.use_box_text {
  margin-bottom: 70px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  line-height: 26px;
  text-align: center;
}
.apply_electronic_main_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.apply_electronic_main_div_left {
  width: 680px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.apply_electronic_main_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 38px;
  color: #202020;
  line-height: 55px;
  text-align: left;
}

.apply_electronic_main_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  line-height: 26px;
  margin-bottom: 69px;
  margin-top: 21px;
  text-align: left;
}
.apply_electronic_main_div_left_textB {
  font-family: SourceHanSansCN-Regular;
  font-size: 17px;
  color: #292626;
  line-height: 26px;
  margin-bottom: 21px;
  display: flex;
  align-items: center;
  text-align: left;
}
.el-icon-circle-check {
  font-size: 20px;
  margin-right: 10px;
  color: #190dcc;
}
.apply_electronic_main_butts {
  display: flex;
  justify-content: left;
}
.apply_electronic_main_butt {
  text-align: left;
  width: 173px;
  height: 55px;
  border-radius: 12px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 18px;
  color: #0c4ce1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #749bf3;
  margin-top: 71px;
  cursor: pointer;
}
.apply_electronic_main_divB {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.apply_electronic_main_div_left_H2 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 38px;
  color: #202020;
  line-height: 55px;
  margin-top: 100px;
  margin-bottom: 100px;
}
.apply_electronic_main_divB_div {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.apply_electronic_main_divB_div > div {
  width: 394px;
  height: 102px;
  background: linear-gradient(270deg, #f3f9ff, #fafcff);
  box-shadow: 0 3px 8px 0 rgba(167, 164, 195, 0.49);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 21px 13px 0 21px;
  position: relative;
}
.apply_electronic_main_divB_div > div > div:nth-child(1) {
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #0c4ce1;
  line-height: 26px;
  text-align: left;
}
.apply_electronic_main_divB_div > div > div:nth-child(2) {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 13px;
  color: #565656;
  line-height: 26px;
  margin-top: 6px;
  text-align: left;
}

.apply_electronic_main_divB_div > div > div:nth-child(3) {
  position: absolute;
  width: 38px;
  height: 38px;
  color: #edf3fc;
  background: #3367d6;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);
  border-radius: 50px;
  top: 50%;
  transform: translateY(-50%);
  right: -19px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ad_card {
  width: 374px;
  height: 210px;
  background: #edf3fc;
  border-radius: 11px;
  border: 1px solid #eef2fc;
  box-sizing: border-box;
  padding: 26px 33px 0;
  margin-bottom: 60px;
}
.ad_card_top {
}
.ad_icon {
  width: 44px;
  height: 44px;
  margin-right: 8px;
}
.ad_tit {
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  color: #20232a;
  line-height: 23px;
  margin-top: 16px;
  margin-bottom: 15px;
}
.ad_txt {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #7a8191;
  line-height: 24px;
}
.advantage_center {
  width: 67%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.advantage_center > div {
  display: flex;
  justify-content: space-between;
}
.apply_electronic_main_div_left_H3 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 38px;
  color: #202020;
  line-height: 55px;
  margin-top: 300px;
  margin-bottom: 100px;
}
.ad_card:hover {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  // box-shadow: (to top, #a18cd1 0%, #fbc2eb 100%) 0px 10px 50px;
}

.free_serve {
  width: 95%;
  max-width: 1300px;
  min-height: 300px;
  margin: 100px auto 127px;
  background: url(http://apiupss.ppfly.top/images/free_serve_bg_1.png) no-repeat 50%;
  background-size: cover;
  border-radius: 19px;
  box-sizing: border-box;
  padding: 79px 137px 0;
  display: flex;
  justify-content: space-between;
}
.free_serve .fs_l h2 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 32px;
  color: #edf3fc;
}
.free_serve .fs_l p {
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 18px;
  color: #edf3fc;
  margin-top: 27px;
}
.free_serve .fs_c {
  display: flex;
  flex-wrap: wrap;
  width: 280px;
  justify-content: space-between;
  align-content: flex-start;
}
.free_serve .fs_c .fs_li {
  width: 125px;
  display: flex;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #edf3fc;
  margin-bottom: 20px;
}
.free_serve .fs_r {
  display: flex;
  padding-top: 16px;
}
.free_serve .fs_r .r_btn {
  margin-right: 20px;
  width: 215px;
  height: 64px;
  background: #edf3fc;
  border-radius: 8px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 19px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
